import { AdminWebServicesModule } from '@admin/web-services';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { ItemPreferencesState } from './item-preferences.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([ItemPreferencesState])],
})
export class AdminStatesModule {
  public static forRoot(): ModuleWithProviders<AdminStatesModule> {
    return {
      ngModule: AdminStatesModule,
      providers: [...(AdminWebServicesModule.forRoot().providers ?? [])],
    };
  }
}
